import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useProfile } from "../../context/ProfileContext";
import config from "../../config";

const MyInfo = () => {
  const [isFormVisible, setIsFormVisible] = useState(true);
  const { customerDetails, loader } = useProfile();
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    address: "",
    email: "",
    pincode: "",
  });

  let contact;
  const token = localStorage.getItem("token");

  if (token == null || token == "") {
    window.location.href = "https://findlocalpetservices.com/";
  } else {
    const decoded = jwtDecode(token);
    contact = decoded.data.customer_data.contact;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Sync customerDetails from ProfileContext to local formData
  useEffect(() => {
    if (customerDetails && Object.keys(customerDetails).length > 0) {
      setFormData(customerDetails);
    }
  }, [customerDetails]);
  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const contact = decoded.data.customer_data.contact;

    // Ensure contact is included in request body
    const updatedData = {
      ...formData,
      contact,
    };

    try {
      const response = await fetch(`${config.API_BASE_URL}/customer/updtecustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        toast.error("Profile not updated, please try again", {
          position: "top-center",
        });
        return;
      }

      const data = await response.json();
      toast.success("Profile updated successfully", { position: "top-center" });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <div className="p-4 bg-white rounded shadow-md md:block hidden">
        <div
          className="flex justify-between items-center font-bold text-xl pb-2 cursor-pointer"
          onClick={toggleFormVisibility}
        >
          <h2>My Info</h2>
          {!isFormVisible ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        {isFormVisible && (
          <form className="space-y-2 mt-4">
            <input
              type="text"
              placeholder="Full Name"
              className="w-full p-2 border rounded bg-[#F8F8F8]"
              name="name"
              value={formData?.name}
              onChange={handleChange}
              disabled
            />
            <input
              type="email"
              placeholder="Email id"
              className="w-full p-2 border rounded bg-[#F8F8F8]"
              name="email"
              value={formData?.email}
              onChange={handleChange}
              disabled
            />
            <input
              type="text"
              placeholder="Address"
              className="w-full p-2 border rounded bg-[#F8F8F8]"
              name="address"
              value={formData?.address}
              onChange={handleChange}
              disabled
            />
            <input
              type="number"
              placeholder="Pincode"
              className="w-full p-2 border rounded bg-[#F8F8F8]"
              name="pincode"
              value={formData?.pincode}
              onChange={handleChange}
              minLength={6}
              maxLength={6}
              disabled
            />
            {/*<input type="text" placeholder="Phone Number" className="w-full p-2 border rounded" name='contact' value={contact} disabled/>
        <input type="text" placeholder="City" className="w-full p-2 border rounded" name="city" value={formData.city} onChange={handleChange} />
        <input type="text" placeholder="State" className="w-full p-2 border rounded" name="state" value={formData.state} onChange={handleChange} />*/}
            {/*<button
            type="submit"
            className="w-[130px] h-[45px] p-2 mt-4 text-orange-500 bg-white border-[#FF6216] border rounded"
            onClick={handleSubmit}
          >
            Edit Profile
          </button>*/}
            <Link
              to="/editprofile"
              className="w-[130px] block h-[45px] p-2 mt-2 text-[#FF6216] bg-white border-[#FF6216] border rounded text-center font-bold"
            >
              Edit Profile
            </Link>
          </form>
        )}
      </div>
      <div className="p-4 bg-white rounded shadow-md md:hidden block">
        <h1 className="font-bold text-[30px] capitalize">{formData?.name}</h1>
        <h2 className="text-[20px]">Mobile: {formData?.contact}</h2>

        <Link
          to="/editprofile"
          className=" mt-2 text-[#FF6216] bg-white border-[#FF6216] border-b  font-bold"
        >
          Edit Profile
        </Link>
      </div>
    </>
  );
};

export default MyInfo;
